import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class HdLinkToMasterService {

  private url: any;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  new(token: any, task: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/new?page=1`, params, { headers });
  }

   update(token: any, id: any, task: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/edit/${id}?page=1`, params, { headers });
  }

  updateSerialHD(token: any, task: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/updateserialnumber`, params, { headers });
  }



  listElementsByReport(token: any, id_report: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinkreport/list/${id_report}`, params, { headers });
  }

  newElementForReport(token: any, report_id: any, task: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ report_id, data: task }));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinkreport/new`, params, { headers });
  }


  searchHDLinkToMaster(token: any, task: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/search`, params, { headers });
  }

  getReport(token: any, ponum: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ type: "HDLINKTOMASTER" }));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/report/detailbypo/${ponum}?page=1`, params, { headers });
  }

  removeElementFromReport(token: any, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinkreport/remove/${id}`, params, { headers });
  }

  searchElements(token: any, type: any, q: any): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ q, type }));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinkreport/search`, params, { headers });
  }

  newReport(token: any, ponum: any): Observable<any> {
    const identity = JSON.parse(localStorage.getItem("identity"));
    const date = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    const task = { user_id: identity.sub, po: ponum, name: date, type: "HDLINKTEMP", data: null };
    const json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/report/new?page=1`, params, { headers });
  }

  list(token: any, page = null): Observable<any> {
    if (page === null) {
      page = 1;
    }
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/list?page=${page}`, params, { headers });
  }

  gethdlink(token: any, id: any, page = null): Observable<any> {
    if (page === null) {
      page = 1;
    }
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/detail/${id}?page=${page}`, params, { headers });
  }

  remove(token: any, id: any, page = null): Observable<any> {
    if (page === null) {
      page = 1;
    }
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post<any>(`${this.url}/hdlinktomaster/remove/${id}?page=${page}`, params, { headers });
  }


}
